export interface UserFunctionDef {
  value: string;
  label: string;
}

export const USER_FUNCTIONS: UserFunctionDef[] = [
  { value: 'share', label: '商品共有・Amazon通知' },
  { value: 'kojima', label: 'コジマ' },
  { value: 'biccamera', label: 'ビックカメラ' },
  { value: 'rakuten', label: '商品検索' },
  { value: 'iris', label: 'アイリス' },
  { value: 'spreadsheet', label: 'ヤマダ・エディオン' },
  { value: 'discontinue', label: '廃盤商品' },
  { value: 'donki', label: 'ドンキ' },
  { value: 'aeon', label: 'イオン' },
  { value: 'openClose', label: '開店閉店' },
  { value: 'user', label: 'ユーザ管理' },
  { value: 'amazonPriceTracking', label: 'Amazon価格追跡' },
  { value: 'keepa', label: 'Keepa連携' },
];

export const FUNC_KEYS = Object.fromEntries(USER_FUNCTIONS.map((f) => [f.value, f.value])) as Record<string, string>;
